// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1bP7f","content":"LayoutSettings_content__1fAIw"};